import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import * as bootstrap from 'bootstrap';
import { Modal } from 'bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { SocietyService } from 'src/app/services/society.service';
import { ToastService } from 'src/app/toast/toast.service';
import * as CryptoJS from 'crypto-js';
import { EncryptionService } from 'src/app/services/encryption.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReTRANSLATIONS_EN, TRANSLATIONS_EN } from 'src/app/i18n/translations.en';
import { ReTRANSLATIONS_HI, TRANSLATIONS_HI } from 'src/app/i18n/translations.hi';



@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})

export class RegistrationComponent implements OnInit {
  userForm: FormGroup;
  isSubmit: boolean = false;
  id: number = 0;
  isLoading: boolean = false;
  data: any;
  txtOTPNumber: any;
  isOTP: boolean = false;
  spacecount: number = 0;




  otp = {
    otpCode: ''
  }

  generatedOtp: number = 0;
  otpError: string = '';
  emailVerified: boolean = false;

  phoneVerfied = false;
  emailVerfied: boolean = false;
  OTPNumberEmail: string | null = null;
  OTPNumber: string | null = null;

  countdownEmail: string = '';
  countdownMobile: string = '';

  timerIntervalEmail: any;
  timerIntervalMobile: any;

  resetTimeoutEmail: any;
  resetTimeoutMobile: any;
  currentYear: any
  maskString: string = '';
  txtOTPNumberEmail: string = '';
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastService: ToastService,
    private route: ActivatedRoute,
    private societyService: SocietyService,
    private commonService: CommonService,
    private encryptService: EncryptionService,
    private ngxService: NgxUiLoaderService
  ) {

    this.userForm = this.fb.group({
      iSocietyUserId: [0],
      sName: ['', [Validators.required, Validators.min(5), Validators.max(40), Validators.pattern(/^[a-zA-Z]{1,40}/)]],
      sAddressLine1: ['', [Validators.required, Validators.min(20), Validators.max(100)]],

      sAddressLine2: ['', [Validators.max(100)]],
      sSTDcode: ['', [Validators.minLength(4), Validators.maxLength(5), Validators.pattern('^[0-9]*$')]],
      sPhone: ['', [Validators.minLength(7), Validators.maxLength(8), Validators.pattern('^[1-9][0-9]*$')]],
      sMobile: ['', [Validators.required, Validators.pattern(/^[6-9]\d{9}$/)]],
      sEmailId: ['', [Validators.required, Validators.max(251), Validators.pattern(/^[a-zA-Z0-9._%+-]{1,60}@[a-zA-Z.-]{1,190}\.[a-zA-Z]{2,}$/)]],



      sPassword: ['', [


        Validators.required,
        Validators.maxLength(16),
        Validators.minLength(8),

        // Validators.pattern('^(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).+$'),
        // Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/)
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[^\s]{8,}$/)
      ]],
      confirmPassword: ['', Validators.required],
    },
      {
        validators: this.passwordMatchValidator(),  // Apply custom validator to the whole form
      }

    );
    this.userForm.get('sPhone')?.valueChanges.subscribe((val) => {
      if (val) {
        this.userForm.get('sSTDcode')?.setValidators([Validators.required]);;

      } else {
        this.userForm.get('sSTDcode')?.clearValidators();
      }
      this.userForm.get('sSTDcode')?.updateValueAndValidity();
    });

  }
   ngAfterViewInit(): void {
    const modalEl = document.getElementById('ProceedInstructionRegister');
    if (modalEl) {
      modalEl.addEventListener('shown.bs.modal', () => {
        const accordions = modalEl.querySelectorAll('.accordion-collapse');
        accordions.forEach((acc: any) => acc.classList.remove('show'));
      });
    }
  }
  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    

  }


  validateEmailCharacters(event: KeyboardEvent): boolean {
    //this.phoneVerfied = false
    const allowedRegex = /^[a-zA-Z0-9@._-]+$/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!allowedRegex.test(inputChar)) {
      event.preventDefault();
      return false;
    }
    return true;
  }


  passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.get('sPassword');
      const confirmPassword = control.get('confirmPassword');

      return password && confirmPassword && password.value !== confirmPassword.value
        ? { passwordsMismatch: true }
        : null;
    };
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }


  allowOnlyCharacters(event: KeyboardEvent) {

    const charCode = event.charCode;
    if (this.spacecount === 1 && charCode === 32) {
      event.preventDefault();
      return false;
    }
    // Allow A-Z and a-z only
    if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || charCode === 32) {
      this.spacecount = 0;
      if (charCode === 32) {
        this.spacecount = 1;
      }

      return true;
    }

    event.preventDefault();
    return false;
  }
  public otpCode: any = ''
  otpPhoneError = false
  mobileOtp() {

    if (this.userForm.controls['sMobile'].valid) {

      this.otpCode = Math.floor(100000 + Math.random() * 900000);
      this.openModal('otpPhoneModal')
    }

  }

  otpVerify(otp: any) {
    let output = Number(otp)
    if (this.userForm.controls['sMobile'].valid && (output == this.otpCode)) {
      this.phoneVerfied = true;
      this.otpCode = ""
      this.hideModal('otpPhoneModal')
    } else {
      this.otpPhoneError = true
    }
  }

  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      // const modal = new Modal(modalElement);
      // modal.hide();
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }

  closeOtPModel() {
    this.otpCode = ''
  }
  onSubmit() {
    this.isSubmit = true;

    if (this.userForm.invalid) {
      const invalidFields = Object.keys(this.userForm.controls).filter(
        (key) => this.userForm.get(key)?.invalid
      );

      return;
    }
    if (!this.phoneVerfied) {
      this.toastService.showError("Please verify Mobile Number.");
      return;
    }
    if (!this.emailVerified) {
      this.toastService.showError("Please verify Email Id.");
      return;
    }
    this.data = this.userForm.value;
    this.data.sAddress = this.data.sAddressLine1 + ',' + this.data.sAddressLine2;
    // return;
    this.ngxService.start();
    this.societyService.registration(this.userForm.value).subscribe({
      next: (response) => {
        this.ngxService.stop();
        if (response.status === 200) {
          this.toastService.showSuccess(response.message);
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 2000);

        } else {
          this.toastService.showError(response.message);
        }
      },
      error: (error) => {
        this.ngxService.stop();
        this.toastService.showError(error.message);
      },
    });

  }
  trimName(Fields: string) {


    const control = this.userForm.get(Fields);
    const trimmed = control?.value?.toString().replace(/\s+/g, ' ').trim();
    if (control && trimmed !== control.value) {
      control.setValue(trimmed, { emitEvent: false });
    }
  }



  emailVerify() {
    if (this.userForm.controls['sEmailId'].valid) {
      this.emailVerified = true;
    }
  }
  verifyOtp() {
    
    this.generatedOtp = Math.floor(100000 + Math.random() * 900000);

    if (!this.otp.otpCode || this.otp.otpCode.toString().length !== 6) {
      this.otpError = 'Please enter a valid 6-digit OTP.';
      return;
    }

    if (parseInt(this.otp.otpCode) === this.generatedOtp) {
      this.emailVerified = true;
      this.otpError = '';
      this.closeModal('otpModal');
      this.toastService?.showSuccess?.('Email verified successfully!');
      window.location.reload();
    } else {
      this.otpError = 'Invalid OTP. Please try again.';
    }
  }
  verifyOTP(flag: any) {

    if (flag == 1) {
      if (this.txtOTPNumberEmail === this.OTPNumberEmail) {
        this.emailVerified = true;
        this.toastService.showSuccess('OTP verified successfully.');
        this.txtOTPNumberEmail = '';
        this.closeModal('otpEmailModal');
      }
      else {
        this.emailVerified = false;
        this.toastService.showError('Please enter a valid 6-digit OTP.');
      }
    }
    if (flag == 2) {
      if (this.txtOTPNumber === this.OTPNumber) {
        this.phoneVerfied = true;
        this.toastService.showSuccess('OTP verified successfully.');
        this.txtOTPNumber = '';
        this.closeModal('otpPhoneModal');
      }
      else {
        this.phoneVerfied = false;
        this.toastService.showError('Please enter a valid 6-digit OTP.');
      }
    }
  }

  closeModal(modalId: string) {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      modalInstance?.hide();
    }
  }
  checkDuplicateEmailOrMobile(flag:any){
    let emailId='';
    let mobile='';
    if(flag==1){
       const control = this.userForm.get('sEmailId');
      if (control?.valid) {
        this.maskString = this.maskMobileOrEmail(this.userForm.get('sEmailId')?.value,1);
        emailId = this.userForm.get('sEmailId')?.value;
        if(this.OTPNumberEmail){
          this.openModal('otpEmailModal');
          return;
        }
      }else{
        return;
      }
    }
    if(flag==2){
      const control = this.userForm.get('sMobile');
      if (control?.valid) {
        this.maskString = this.maskMobileOrEmail(this.userForm.get('sMobile')?.value,2);
        mobile = this.userForm.get('sMobile')?.value;
        if(this.OTPNumber){
          this.openModal('otpPhoneModal');
          return;
        }
      }else{
        return;
      }

    }
    this.ngxService.start();
    this.commonService.CheckDuplicateEmailOrMobile(emailId, mobile).subscribe((response) => {
      if (response.status === 200) {
          // const cipherText = response.data.cipherText;
          // const iv = response.data.iv;
          // const plainText = this.encryptService.decrypt(cipherText, iv);
          const plainText = response.data;
          
           // Start 10-minute timer
          const totalSeconds = 600;
          let secondsLeft = totalSeconds;
          if (flag === 1) {
            this.OTPNumberEmail = plainText;
            this.updateCountdown(flag, secondsLeft);
            this.timerIntervalEmail = setInterval(() => {
              secondsLeft--;
              this.updateCountdown(flag, secondsLeft);
              if (secondsLeft <= 0) this.clearDecryptedText(flag);
            }, 1000);

            this.resetTimeoutEmail = setTimeout(() => this.clearDecryptedText(flag), totalSeconds * 1000);
            this.ngxService.stop();
            this.openModal('otpEmailModal');
          }

          if (flag === 2) {
            this.OTPNumber = plainText.otp;
            this.updateCountdown(flag, secondsLeft);
            this.timerIntervalMobile = setInterval(() => {
              secondsLeft--;
              this.updateCountdown(flag, secondsLeft);
              if (secondsLeft <= 0) this.clearDecryptedText(flag);
            }, 1000);

            this.resetTimeoutMobile = setTimeout(() => this.clearDecryptedText(flag), totalSeconds * 1000);
            this.ngxService.stop();
            this.openModal('otpPhoneModal');        
          }

      }else{
        this.ngxService.stop();
        this.toastService.showError(response.message);
        if(flag==2){
        this.userForm.controls['sMobile'].setValue('');
        return;
        }
        if(flag==1){
        this.userForm.controls['sEmailId'].setValue('');
        return;
        }

      }
    })
  }



  clearDecryptedText(flag: number) {
    if (flag === 1) {
      this.OTPNumberEmail = null;
      clearInterval(this.timerIntervalEmail);
      clearTimeout(this.resetTimeoutEmail);
      this.countdownEmail = '';
    } else if (flag === 2) {
      this.OTPNumber = null;
      clearInterval(this.timerIntervalMobile);
      clearTimeout(this.resetTimeoutMobile);
      this.countdownMobile = '';
    }
  }

  updateCountdown(flag: number, secondsLeft: number) {
    const minutes = Math.floor(secondsLeft / 60);
    const seconds = secondsLeft % 60;
    const display = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

    if (flag === 1) {
      this.countdownEmail = display;
    } else if (flag === 2) {
      this.countdownMobile = display;
    }
  }

  maskMobileOrEmail(input: string, flag: number): string {
    if (flag === 1) {
      // Email masking
      const [username, domain] = input.split('@');
      if (!domain) return input; // Invalid email
      if (username.length <= 2) {
        return '*'.repeat(username.length) + '@' + domain;
      }
      const firstChar = username.charAt(0);
      const lastChar = username.charAt(username.length - 1);
      const maskedMiddle = '*'.repeat(username.length - 2);
      return `${firstChar}${maskedMiddle}${lastChar}@${domain}`;
    }

    if (flag === 2) {
      // Mobile masking
      return input.length === 10
        ? input.replace(/^(\d{2})\d{6}(\d{2})$/, '$1XXXXXX$2')
        : input;
    }

    return input;
  }


  openOTPModal(modalId: string) {
    this.ngxService.start();
    //this.openModal(modalId);
  }

  // Theme & Language
  isDark = false;
  isEnglish = true;

  // Captcha
  captchaCode = '';

  // Translations
  translations = ReTRANSLATIONS_EN;



  // Theme Toggle
  toggleTheme(): void {
    this.isDark = !this.isDark;
    document.documentElement.classList.toggle('dark', this.isDark);

  }

  // Language Toggle
  toggleLanguage(): void {
    this.isEnglish = !this.isEnglish; // Toggle the language flag

    // Update translations based on the current language
    this.translations = this.isEnglish ? ReTRANSLATIONS_EN : ReTRANSLATIONS_HI;
  }


}
